import React, { useMemo, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Outlet,
  useLocation,
} from "react-router-dom";
import theme from "./theme";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";

// const App = () => {
//   // Define Unity context with appropriate URLs
//   const { unityProvider } = useUnityContext({
//     loaderUrl: "unity-webgl/build/DNCycleWebGL.loader.js",
//     dataUrl: "unity-webgl/build/DNCycleWebGL.data",
//     frameworkUrl: "unity-webgl/build/DNCycleWebGL.framework.js",
//     codeUrl: "unity-webgl/build/DNCycleWebGL.wasm",
//     webglContextAttributes: {
//       preserveDrawingBuffer: true,
//     },
//   });
// }

import Impressum from "./pages/footer/Impressum.jsx";
import Datenschutz from "./pages/footer/datenschutz.jsx";
import Barrierefreiheit from "./pages/footer/barrierefreiheit.jsx";


import SessionManager from "./components/SessionManager";




import Register from "./pages/Register";
import Login from "./pages/Login";
//import Write from "./pages/Write";
import StoryEditor from "./pages/story-editor/StoryEditor";



import StoryReader from "./pages/StoryReader";
import Home from "./pages/Home";



import Classes from "./pages/Classes.jsx";
import Klasse from "./pages/Klasse.jsx";
import Groups from "./pages/Groups";
import Group from "./pages/Group.jsx";
import DMCPanel from "./pages/DMCPanel.jsx";
import ReflectionForm from "./pages/ReflectionForm";
import Studio from "./pages/Studio.jsx";


import StoriesGallery from "./pages/StoriesGallery.jsx";
import Activities from "./pages/Activities.jsx";


import ActivityTasks from "./pages/Tasks.jsx";

import TeacherDashboard from "./pages/dashboard/TeacherDashboard.jsx";


import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import OperationMenu from "./components/OperationMenu";

import { ConfigProvider } from "antd";
import "./css/style.scss";
import { Layout, Button, message, notification, Space } from "antd";

import ProtectedRoute from "./context/ProtectedRoute";
const Context = React.createContext({
  name: "Default",
});
const { Header, Sider, Content } = Layout;

const Layout1 = ({ presentationMode, setPresentationMode }) => {
  const location = useLocation();
  const hideChrome = location.pathname === "/Studio";
  const effectivePresentationMode = presentationMode || hideChrome;

  return (
    <>
     <Navbar
        presentationMode={effectivePresentationMode}
        setPresentationMode={setPresentationMode}
      />

      <Content style={{ flex: 1 }}>
        <Outlet />
      </Content>

      <Footer
        presentationMode={effectivePresentationMode}
        setPresentationMode={setPresentationMode}
      />
    </>
  );
};

const opts = {
  enableTouchEvents: true, // Enable touch-based event processing
  enableMouseEvents: true, // Enable touch-based event processing
  // ... other options
};

function App() {
  const [api, contextHolder] = notification.useNotification();
  const Context = React.createContext({ name: "Default" });
  const [presentationMode, setPresentationMode] = useState(false);

  const contextValue = useMemo(() => ({ name: "Ant Design" }), []);
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <Layout1
          presentationMode={presentationMode}
          setPresentationMode={setPresentationMode}
        />
      ),
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/storyEditor",
          element: <ProtectedRoute component={StoryEditor} />,
        },
        {
          path: "/classes",
          element: <ProtectedRoute component={Classes} />,
        },
        {
          path: "/class/:id",
          element: <ProtectedRoute component={Klasse} />,
        },
        {
          path: "/groups",
          element: <ProtectedRoute component={Groups} />,
        },
        {
          path: "dmcPanel",
          element: <ProtectedRoute component={DMCPanel} />,
        },
        {
          path: "/group/:id",
          element: <ProtectedRoute component={Group} />,
        },
        {
          path: "/reflection/:taskId/:reflectionType",
          element: <ProtectedRoute component={ReflectionForm} />,
        },
        {
          path: "/studio",
          element: <ProtectedRoute component={Studio} />,
        },

        {
          path: "/storiesGallery",
          element: <ProtectedRoute component={StoriesGallery} />,
        },   
        {
          path: "/activities",
          element: <ProtectedRoute component={Activities} />,
        },

        {
          path: "/activities/:id",
          element: <ProtectedRoute component={ActivityTasks} />,
        },

        {
          path: "/teacherDashboard",
          element: <ProtectedRoute component={TeacherDashboard} />,
        },

        {
          path: "/StoryReader",
          element: (
            <ProtectedRoute
              component={() => (
                <StoryReader
                  presentationMode={presentationMode}
                  setPresentationMode={setPresentationMode}
                />
              )}
            />
          ),
        },
      
        {
          path: "/operationMenu",
          element: <ProtectedRoute component={OperationMenu} />,
        },
        {
          path: "/impressum",
          element: <Impressum />,
        },
        {
          path: "/datenschutz",
          element: <Datenschutz />,
        },
        {
          path: "/barrierefreiheit",
          element: <Barrierefreiheit />,
        },        
      ],
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/login",
      element: <Login />,
    },

   
  ]);
  return (
    /*<Context.Provider value={contextValue}>
      {contextHolder}
       <Button style={{fontSize:'32px'}} onClick={() => {
                openNotification('bottomRight','Logged out successfully!');
                }} icon={<RadiusBottomrightOutlined />} /> */
                <Layout
                className="app"
                style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
              >
                <Layout className="container" style={{ flex: 1 }}>
        <DndProvider backend={TouchBackend} options={opts}>
          <SessionManager />
          <RouterProvider router={router} />
        </DndProvider>
      </Layout>
    </Layout>
    // </Context.Provider>
  );
}

export default App;
